import { Component } from '@angular/core';

@Component({
  selector: 'app-team-admin-home',
  templateUrl: './team-admin-home.component.html',
  styleUrls: ['./team-admin-home.component.scss'],
  standalone: false
})
export class TeamAdminHomeComponent {

}
